import { Component } from '@angular/core';
import { EmployeeDashboardService } from '../../services/employee-dashboard.service';

@Component({
    selector: 'app-my-work',
    templateUrl: './my-work.component.html',
    styleUrls: ['./my-work.component.css'],
    standalone: false
})
export class MyWorkComponent {

    constructor(
    private dashboardService: EmployeeDashboardService
  ) {}

  applyLeave() {
    // this.http.post('/api/leaves/apply', {})
    //   .subscribe(() => {
    //     this.dashboardService.increment('leaveRequests');
    //   });
  }

}
